import React from 'react';
import GenericDivider from 'src/components/GenericDivider/GenericDivider';
import FontAwesomeIcon from 'src/components/Icon';
import Tooltip from 'src/components/Tooltip/Tooltip';
import SchedulingSlotSummary from 'src/components/ServiceRequestForm/TimeSlot/SchedulingSlotSummary';
import './preferred-times-summary.scss';

const PREFERRED_TIMES_HINT: string =
  "Times the homeowner said work for them, captured when the request was submitted. They're shown for reference only — you can still schedule outside these windows.";

interface PreferredTimesSummaryProps {
  preferredDays: string[];
  preferredEntries: string[];
  activePreferredDay: string | null;
  onPreferredDaySelect: (day: string) => void;
}

const PreferredTimesSummary = ({
  preferredDays,
  preferredEntries,
  activePreferredDay,
  onPreferredDaySelect,
}: PreferredTimesSummaryProps) => {
  if (preferredDays.length === 0) {
    return null;
  }

  return (
    <>
      <div className="preferred-times-summary">
        <h3 className="scheduling-section-heading">
          Homeowner's Preferred Available Times
          <Tooltip content={PREFERRED_TIMES_HINT}>
            <span className="preferred-times-info">
              <FontAwesomeIcon glyph="info-circle" weight="light" />
            </span>
          </Tooltip>
        </h3>
        {/* time-slot/slot-control reuse the shared TimeSlot skin so the tabs
            match the rest of this screen. */}
        <div className="time-slot">
          <div className="slot-control">
            <SchedulingSlotSummary
              filterDay={preferredDays}
              filterTab={activePreferredDay}
              selection={preferredEntries}
              onFilterTabSelect={onPreferredDaySelect}
            />
          </div>
        </div>
      </div>
      <GenericDivider variant="sky" spacing="lg" />
    </>
  );
};

export default PreferredTimesSummary;
